import { createContext } from "react";

export const DatasheetContext = createContext(undefined);
